export const validFileTypes = [
  'image/jpeg',
  'image/png',
  'image/heic',
  'application/pdf',
  // ZIP
  'application/zip',
  'application/x-zip',
  'application/x-zip-compressed',
  'application/x-compressed',
  'multipart/x-zip',
  // 7-Zip
  'application/x-7z-compressed',
  'application/7z',
];

export const isValidFile = (file: File) => {
  // zip & 7zip
  const validFileTypes = [
    'image/jpeg',
    'image/png',
    'image/heic',
    'application/pdf',
    // ZIP
    'application/zip',
    'application/x-zip',
    'application/x-zip-compressed',
    'application/x-compressed',
    'multipart/x-zip',
    // 7-Zip
    'application/x-7z-compressed',
    'application/7z',
  ];
  const maxSize = 25000000;
  return {
    isValid: validFileTypes.includes(file.type) && file.size <= maxSize,
    validType: validFileTypes.includes(file.type),
    validSize: file.size <= maxSize,
  };
};
